import axios from 'axios'

export const get = (url) => (
    axios
        .get(url)
        .then(({ data: result }) => (
            result
        ))
        .catch((error) => {
            throw error
        })
)
